import React from 'react';

import { Modal, ModalHeader, ModalBody, ModalFooter } from "../../../../components/Modal";
import CustomButton from "../../../../components/CustomButton";

import { useTranslation } from 'react-i18next';

import { CalendarWeek as CalendarIcon, Clock } from "flowbite-react-icons/outline";
import {dateFormatHourMinute} from "../../../../helpers/dateFunctions";
import {getLanguage} from "../../../../lang/helpers";

interface ConfirmBookingModalProps {
    onClickButton: () => void;
    onClose: () => void;
    isOpen: boolean;
    coachName: string;
    selectedDate: Date|null;
    meetingLength?: number;
    meetingId: string|null;
}

const ConfirmBookingModal: React.FC<ConfirmBookingModalProps> = ({ onClickButton, onClose, isOpen, coachName,
                                                                     selectedDate, meetingLength, meetingId }) => {
    const { t, i18n } = useTranslation();
    const lang = getLanguage(i18n.language)

    if (!selectedDate) {
        return null;
    }

    // convert date to format dd month name for example 18 nov
    const date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long',
    })

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader onClose={onClose}>
                <div className="z-title1">
                    {meetingId ? t('change-meeting') : t('confirm-booking')}
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="flex flex-col justify-start align-middle gap-3 ">
                    <div className="flex flex-row align-middle items-center gap-1">
                        <p className="z-body1">
                            {
                                meetingId ?
                                  lang === 'sv' ? 'Vill du ändra tiden för mötet med ' :
                                  'Do you want to change the time for the videocoaching session with ' :
                                  lang === 'sv' ? 'Vill du boka ett möte med ' :
                                    'Do you want to book a videocoaching session with '
                            }
                            { coachName }
                        </p>
                    </div>

                    <div className="flex flex-row align-middle items-center gap-1">
                        <CalendarIcon className="w-6 h-6" aria-hidden="true" />
                        <p className="z-body1">
                            {date}
                        </p>
                    </div>

                    <div className="flex flex-row align-middle items-center gap-1">
                        <Clock className="w-6 h-6" aria-hidden="true" />
                        <p className="z-body1">
                            {dateFormatHourMinute(selectedDate)}
                            {
                                meetingLength &&
                              <span className="ml-1">({meetingLength} {lang === "sv" ? "minuter" : "minutes"})</span>
                            }
                        </p>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="flex w-full">
                    <CustomButton onClick={onClose} buttonType="outlineWhiteBase">
                        {t('cancel')}
                    </CustomButton>
                    <CustomButton onClick={onClickButton} className="ml-4">
                        {t('confirm')}
                    </CustomButton>
                </div>

            </ModalFooter>
        </Modal>
    );
};

export default ConfirmBookingModal;